import Slider, {SliderComponent} from "./slider"

interface ProductSliderComponent {
  init(): void;
  scrollMainTo(index: number): void;
  scrollThumbsTo(index: number): void;
  scrollZoomTo(index: number): void;
  openZoomModal(): void;
  closeZoomModal(): void;
  bodyScrollLock(shouldLock: boolean): void;
  main: SliderComponent | null;
  thumbs: SliderComponent | null;
  zoom: SliderComponent | null;
  zoomOpen: boolean;
  mainIndex: number;
  hasBodyLock: boolean;
  bodyLocksCount: number;
  savedScrollY: number;
  $refs?: {
    mainWrapper: HTMLElement;
    thumbsWrapper: HTMLElement;
  };
  $el?: HTMLElement;
}

export default {
  name: 'productSlider',
  component(): ProductSliderComponent {
    return {
      main: null,
      thumbs: null,
      zoom: null,
      mainIndex: 0,
      zoomOpen: false,
      hasBodyLock: false,
      bodyLocksCount: 0,
      savedScrollY: 0,
      init() {
        
        this.main = Slider.component();
        this.thumbs = Slider.component();
        this.zoom = Slider.component();

        if (!this.main || !this.$refs || !this.thumbs) return;

        this.main.init(this.$refs.mainWrapper, {}, false);
        this.thumbs.init(this.$refs.thumbsWrapper, {}, true);
        this.zoom.init(this.$refs.zoomWrapper, {}, true);

        // on main click, open zoom modal
        this.$refs.mainWrapper.addEventListener('click', () => {
          this.openZoomModal();
        });

        // Synchronisation miniatures → principal
        this.$refs.thumbsWrapper.addEventListener('click', (e) => {
          const target = e.target as HTMLElement;
          const slide = target.closest('.embla__slide') as HTMLElement;
          if (slide) {
            const index = parseInt(slide.dataset.index || '0');
            this.scrollMainTo(index);
            this.scrollZoomTo(index);
          }
        });

        // Synchronisation principal → miniatures et zoom
        if (this.main.embla) {
          this.main.embla.on('select', () => {
            const selectedIndex = this.main.embla.selectedScrollSnap();
            this.mainIndex = selectedIndex;
            this.scrollThumbsTo(selectedIndex);
            this.scrollZoomTo(selectedIndex);
          });
        }

        // Synchronisation principal → zoom
        if (this.zoom.embla) {
          this.zoom.embla.on('select', () => {
            const selectedIndex = this.zoom.embla.selectedScrollSnap();
            this.scrollMainTo(selectedIndex);
            this.scrollThumbsTo(selectedIndex);
          });
        }

      
        const mediaContainer = document.querySelector('[data-prodify-media-container]');
        if (mediaContainer) {
          mediaContainer.addEventListener('spanish-image-updated', (e: CustomEvent) => {
           
            if (this.main && this.thumbs) {
              // Réinitialiser les sliders
              this.main.embla?.reInit();
              this.thumbs.embla?.reInit();
              
              // Attendre que reInit soit terminé avant de scroller
              setTimeout(() => {
                this.main.scrollTo(0);
                this.thumbs.scrollTo(0);
              }, 300);
            }
          });

          mediaContainer.addEventListener('italian-image-updated', (e: CustomEvent) => {
           
            if (this.main && this.thumbs) {
              // Réinitialiser les sliders
              this.main.embla?.reInit();
              this.thumbs.embla?.reInit();
              
              // Attendre que reInit soit terminé avant de scroller
              setTimeout(() => {
                this.main.scrollTo(0);
                this.thumbs.scrollTo(0);
              }, 300);
            }
          });
        }
      },
      scrollMainTo(index: number) {
        if (this.main) {
          this.main.scrollTo(index);
        }
      },
      scrollThumbsTo(index: number) {
        if (this.thumbs) {
          this.thumbs.scrollTo(index);
        }
      },
      scrollZoomTo(index: number) {
        if (this.zoom) {
          this.zoom.scrollTo(index);
        }
      },

      openZoomModal() {
        this.zoomOpen = true;
        if (this.zoom && typeof this.mainIndex === 'number') {
          setTimeout(() => {
            this.zoom.scrollTo(this.mainIndex);
          }, 50);
        }
        this.bodyScrollLock(true);
      },

      closeZoomModal() {
        this.zoomOpen = false;
        this.bodyScrollLock(false);
      },

      bodyScrollLock(shouldLock) {
        if (shouldLock) {
          if (!this.hasBodyLock) {
            this.savedScrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.savedScrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100%';
            this.hasBodyLock = true;
          }
          this.bodyLocksCount += 1;
        } else {
          this.bodyLocksCount = Math.max(0, this.bodyLocksCount - 1);
          if (this.hasBodyLock && this.bodyLocksCount === 0) {
            document.body.style.removeProperty('position');
            document.body.style.removeProperty('top');
            document.body.style.removeProperty('width');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('height');
            window.scrollTo(0, this.savedScrollY);
            this.hasBodyLock = false;
          }
        }
      },
    }
  }
}
